export const COMPANY = {
  name: "Generational Health",
  legal: "Generational Health",
  tagline: "Your mind. Your power.",
  city: "Charlotte, North Carolina 28203",
  founder: "Michelle Coffino",
  founderTitle: "Owner & Founder",
  website: "generationalh.com",
  logo: "/gh-logo.png",
  docTitle: "Federal Partnership Proposal",
  docSubtitle: "An AI-Driven Behavioral Health Intelligence Platform for Population Health, Program Integrity, and Measurable Outcomes",
  version: "v2.0",
  date: "2026",
};

export const RECIPIENTS = [
  "Office of the Governor of North Carolina",
  "Centers for Medicare & Medicaid Services (CMS)",
  "U.S. Department of Health & Human Services (HHS)",
  "Substance Abuse & Mental Health Services Administration (SAMHSA)",
  "U.S. Department of Veterans Affairs (VA)",
  "Members of the United States Congress",
];

export const NAV = [
  { id: "exec-summary", n: 1, title: "Executive Summary" },
  { id: "crisis", n: 2, title: "The National Behavioral Health Crisis" },
  { id: "gaps", n: 3, title: "Why Current Systems Fall Short" },
  { id: "solution", n: 4, title: "The Generational Health Solution" },
  { id: "ai-architecture", n: 5, title: "AI Architecture" },
  { id: "population-health", n: 6, title: "Population Health Management" },
  { id: "medicaid", n: 7, title: "Medicaid Integration" },
  { id: "medicare", n: 8, title: "Medicare Integration" },
  { id: "va", n: 9, title: "Veterans Affairs Integration" },
  { id: "security", n: 10, title: "HIPAA & Security Framework" },
  { id: "interoperability", n: 11, title: "Interoperability (FHIR / HL7)" },
  { id: "dashboards", n: 12, title: "Enterprise Dashboards" },
  { id: "track-trace", n: 13, title: "Track-and-Trace Capabilities" },
  { id: "program-integrity", n: 14, title: "Program Integrity & Oversight" },
  { id: "population-analytics", n: 15, title: "Population Analytics" },
  { id: "outcomes", n: 16, title: "Outcome Measurement Framework" },
  { id: "roi", n: 17, title: "ROI & Evaluation Methodology" },
  { id: "ed-utilization", n: 18, title: "Emergency Department Utilization" },
  { id: "readmissions", n: 19, title: "Readmission Tracking" },
  { id: "cost-of-care", n: 20, title: "Cost-of-Care Analytics" },
  { id: "workforce", n: 21, title: "Workforce & Provider Optimization" },
  { id: "pilot", n: 22, title: "Pilot Implementation Plan" },
  { id: "roadmap", n: 23, title: "12-Month Roadmap" },
  { id: "scalability", n: 24, title: "National Scalability" },
  { id: "partnership", n: 25, title: "Federal Partnership Proposal" },
  { id: "references", n: 26, title: "References & Methodology" },
];

// ---- Chart data ----
export const crisisData = [
  { label: "Any mental illness (adults)", value: 59.3, unit: "M" },
  { label: "Serious mental illness", value: 15.4, unit: "M" },
  { label: "Substance use disorder", value: 48.7, unit: "M" },
  { label: "Co-occurring MH + SUD", value: 21.5, unit: "M" },
];

export const prevalenceTrend = [
  { year: "2019", adults: 51.5, youth: 15.1 },
  { year: "2020", adults: 52.9, youth: 16.0 },
  { year: "2021", adults: 57.8, youth: 17.4 },
  { year: "2022", adults: 59.3, youth: 19.5 },
  { year: "2023", adults: 58.7, youth: 20.1 },
];

export const spendingPayer = [
  { name: "Medicaid", value: 26 },
  { name: "Private insurance", value: 25 },
  { name: "Other state / local", value: 19 },
  { name: "Medicare", value: 13 },
  { name: "Out-of-pocket", value: 10 },
  { name: "Other federal", value: 7 },
];

export const edReadmit = [
  { metric: "BH-related ED visits", baseline: 100, projected: 78 },
  { metric: "30-day psych readmits", baseline: 100, projected: 72 },
  { metric: "Crisis stabilization use", baseline: 100, projected: 80 },
  { metric: "Missed appointments", baseline: 100, projected: 65 },
];

export const roiData = [
  { month: "M1", cost: 100, savings: 0, net: -100 },
  { month: "M2", cost: 145, savings: 30, net: -115 },
  { month: "M3", cost: 185, savings: 80, net: -105 },
  { month: "M4", cost: 220, savings: 150, net: -70 },
  { month: "M5", cost: 250, savings: 235, net: -15 },
  { month: "M6", cost: 278, savings: 330, net: 52 },
  { month: "M7", cost: 302, savings: 440, net: 138 },
  { month: "M8", cost: 322, savings: 560, net: 238 },
  { month: "M9", cost: 340, savings: 695, net: 355 },
  { month: "M10", cost: 356, savings: 840, net: 484 },
  { month: "M11", cost: 370, savings: 1000, net: 630 },
  { month: "M12", cost: 382, savings: 1175, net: 793 },
];

export const workforceData = [
  { role: "Psychiatrists", supply: 38, demand: 100 },
  { role: "Psych. NPs / PAs", supply: 52, demand: 100 },
  { role: "Therapists / LCSWs", supply: 61, demand: 100 },
  { role: "Peer specialists", supply: 44, demand: 100 },
  { role: "Care coordinators", supply: 49, demand: 100 },
];

export const outcomesData = [
  { measure: "Engagement", value: 88 },
  { measure: "Adherence", value: 81 },
  { measure: "Follow-up <7d", value: 76 },
  { measure: "PHQ-9 improve", value: 69 },
  { measure: "Retention 90d", value: 73 },
  { measure: "Crisis avoided", value: 64 },
];

export const riskTiers = [
  { tier: "Tier 4 — Acute / crisis", pct: 5, color: "#c2453d", desc: "Active crisis, recent ED or inpatient; intensive coordination" },
  { tier: "Tier 3 — High risk", pct: 15, color: "#d98c2b", desc: "Rising risk, gaps in care, low adherence; proactive outreach" },
  { tier: "Tier 2 — Rising risk", pct: 30, color: "#15a8c2", desc: "Moderate needs; structured engagement & monitoring" },
  { tier: "Tier 1 — Stable", pct: 50, color: "#1f9d6b", desc: "Maintenance; AI companion, reminders, self-management" },
];

export const costOfCareData = [
  { cohort: "No engagement", pmpm: 1840 },
  { cohort: "Standard care", pmpm: 1510 },
  { cohort: "GH-managed (proj.)", pmpm: 1185 },
];

export const REFERENCES = [
  "SAMHSA. Key Substance Use and Mental Health Indicators in the United States: Results from the 2022 National Survey on Drug Use and Health (NSDUH). 2023.",
  "Centers for Disease Control and Prevention (CDC), National Center for Health Statistics. WISQARS Fatal Injury Reports — Suicide, 2022.",
  "CDC. Drug Overdose Deaths in the United States, provisional and final mortality data, 2022–2023.",
  "Health Resources & Services Administration (HRSA). Designated Health Professional Shortage Areas — Mental Health, Quarterly Summary, 2024.",
  "U.S. Department of Veterans Affairs. 2023 National Veteran Suicide Prevention Annual Report. Office of Mental Health and Suicide Prevention.",
  "Medicaid and CHIP Payment and Access Commission (MACPAC). Behavioral Health in the Medicaid Program. 2023.",
  "KFF (Kaiser Family Foundation). Mental Health and Substance Use State Fact Sheets. 2023–2024.",
  "Centers for Medicare & Medicaid Services (CMS). Behavioral Health Strategy and the Medicare Behavioral Health Benefit Expansion. 2024.",
  "SAMHSA. 988 Suicide & Crisis Lifeline Performance Metrics. 2022–2024.",
  "National Committee for Quality Assurance (NCQA). HEDIS Behavioral Health Measures (FUH, FUA, AMM, IET). 2024.",
  "Office of the National Coordinator for Health IT (ONC). United States Core Data for Interoperability (USCDI) & HL7 FHIR US Core. 2024.",
  "HHS Office for Civil Rights. HIPAA Security Rule, 45 CFR Part 164. NIST SP 800-66 Rev. 2.",
  "CMS Interoperability and Patient Access Final Rule (CMS-9115-F) and Advancing Interoperability (CMS-0057-F).",
  "National Council for Mental Wellbeing. The Behavioral Health Workforce Shortage. 2023.",
  "Substance Abuse and Mental Health Services Administration. Projections of National Expenditures for Treatment of Mental and Substance Use Disorders, 2010–2030.",
];
